/**
 * Newsletter 5% first-order auto-apply (WELCOME5).
 *
 * Shopify Admin → Discounts → Create discount code
 * Code: WELCOME5
 * 5% off order · All products · Do not exclude sale items
 * No minimum · Once per customer if available
 * Combinations: allow product discounts
 * Save
 *
 * Storefront uses /discount/CODE — Cart AJAX cannot apply codes.
 */
(function () {
  const cfg = window.GrowMedicaWelcome5 || {};
  if (cfg.enabled === false) return;

  const CODE = String(cfg.code || 'WELCOME5').trim() || 'WELCOME5';
  const COOKIE = 'discount_code';
  const LS_CODE = 'newsletter_discount';
  const LS_SUB = 'newsletter_subscribed';
  const APPLIED = 'discount_applied';
  const i18n = cfg.i18n || {};

  function shopRoot() {
    const r =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.Theme && window.Theme.routes && window.Theme.routes.root) ||
      '/';
    return String(r).replace(/\/$/, '') || '';
  }

  function setCookie(name, val, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      name + '=' + encodeURIComponent(val) + '; path=/; SameSite=Lax; expires=' + d.toUTCString();
  }

  function getCookie(name) {
    const m = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)')
    );
    return m ? decodeURIComponent(m[1]) : '';
  }

  function persist(code) {
    setCookie(COOKIE, code, 14);
    try {
      localStorage.setItem(LS_CODE, code);
    } catch (e) {}
  }

  function markSubscribed() {
    try {
      localStorage.setItem(LS_SUB, '1');
    } catch (e) {}
  }

  function isSubscribed() {
    try {
      return localStorage.getItem(LS_SUB) === '1';
    } catch (e) {
      return false;
    }
  }

  function discountUrl(code, redirectPath) {
    const root = shopRoot();
    const dest = redirectPath || window.location.pathname + window.location.search;
    return root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
  }

  function apply(code, redirectPath) {
    const use = (code || CODE).trim() || CODE;
    persist(use);
    markSubscribed();
    try {
      if (sessionStorage.getItem(APPLIED) === use) return;
      sessionStorage.setItem(APPLIED, use);
    } catch (e) {}
    window.location.assign(discountUrl(use, redirectPath));
  }

  function applyAfterSuccess(uniqueCode) {
    const use = (uniqueCode && String(uniqueCode).trim()) || CODE;
    persist(use);
    markSubscribed();
  }

  function cartHasCode(cart, code) {
    if (!cart) return false;
    const codes = cart.discount_codes || [];
    if (codes.some(function (d) {
      return d && d.code === code && d.applicable !== false;
    })) {
      return true;
    }
    const apps = cart.cart_level_discount_applications || [];
    return apps.some(function (d) {
      return d && (d.title === code || d.code === code);
    });
  }

  function maybeApplyFromCookie() {
    return;
  }

  function uniqueFromKlaviyo(detail) {
    if (!detail) return '';
    const meta = detail.metaData || detail.meta || {};
    return (
      meta.couponCode ||
      meta.uniqueCoupon ||
      meta.shopifyCoupon ||
      detail.couponCode ||
      ''
    );
  }

  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail) return;
    const type = e.detail.type;
    if (type === 'submit' || type === 'stepSubmit' || type === 'redirectedToUrl') {
      applyAfterSuccess(uniqueFromKlaviyo(e.detail));
    }
  });

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (
        form.classList.contains('email-signup__form') ||
        form.querySelector('[name="contact[email]"]')
      ) {
        markSubscribed();
        persist(CODE);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const a = e.target && e.target.closest && e.target.closest('a[href*="/checkout"]');
      if (!a) return;
      const code = getCookie(COOKIE);
      if (!code || a.href.indexOf('discount=') !== -1) return;
      try {
        const u = new URL(a.href, window.location.origin);
        u.searchParams.set('discount', code);
        a.href = u.toString();
      } catch (err) {}
    },
    true
  );

  function isKlaviyoRootCandidate(el) {
    if (!el || el.nodeType !== 1 || !el.matches) return false;
    return el.matches('form[id^="k_id_"], .klaviyo-form, [class*="klaviyo-form"]');
  }

  function insideSignup(el) {
    return !!(el && el.closest && el.closest('.email-signup-block, form.email-signup__form'));
  }

  function insideTeaser(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('[class*="teaser"], [class*="kl-teaser"], [data-testid*="teaser"]')
    );
  }

  function klaviyoRoots() {
    const candidates = document.querySelectorAll(
      'form[id^="k_id_"], .klaviyo-form, [class*="klaviyo-form"]'
    );
    const roots = [];
    candidates.forEach(function (el) {
      if (insideSignup(el) || insideTeaser(el)) return;
      let parent = el.parentElement;
      let nested = false;
      while (parent) {
        if (isKlaviyoRootCandidate(parent)) {
          nested = true;
          break;
        }
        parent = parent.parentElement;
      }
      if (!nested) roots.push(el);
    });
    return roots;
  }

  function isVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    const r = el.getBoundingClientRect();
    const s = window.getComputedStyle(el);
    return r.width > 8 && r.height > 8 && s.visibility !== 'hidden' && s.display !== 'none';
  }

  function isHealthHeadline(text) {
    const t = String(text || '').toLowerCase();
    const keep = String(i18n.health || '').toLowerCase();
    if (keep && t.indexOf(keep) !== -1) return true;
    return (
      /zdravie\s+m[áa]\s+syst/i.test(t) ||
      /zdraví\s+má\s+syst/i.test(t) ||
      /health has a system/i.test(t) ||
      /gesundheit hat ein system/i.test(t) ||
      /egészségnek rendszere/i.test(t)
    );
  }

  function rewriteKlaviyoCopy() {
    const body = String(i18n.body || '').trim();
    if (!body) return;
    klaviyoRoots().forEach(function (root) {
      root.querySelectorAll('.gm-welcome5-offer').forEach(function (el) {
        el.remove();
      });
      const paras = Array.from(root.querySelectorAll('p')).filter(function (p) {
        return isVisible(p) && (p.innerText || '').trim();
      });
      if (!paras.length) return;
      const bodies = [];
      paras.forEach(function (p) {
        if (isHealthHeadline(p.innerText)) return;
        bodies.push(p);
      });
      if (!bodies.length) return;
      const already = bodies[0].innerText.replace(/\s+/g, ' ').trim() === body;
      bodies[0].innerHTML = body.replace(/(5\s*%)/i, '<span class="gm-welcome5-pct">$1</span>');
      bodies.slice(1).forEach(function (p) {
        if (p.classList && p.classList.contains('gm-welcome5-offer__badge')) return;
        p.setAttribute('hidden', '');
        p.style.display = 'none';
      });
      const badgeText = String(i18n.badge || '5% OFF').trim();
      let badgeEl = root.querySelector('.gm-welcome5-offer__badge');
      if (!badgeEl && badgeText) {
        badgeEl = document.createElement('div');
        badgeEl.className = 'gm-welcome5-offer__badge';
        badgeEl.textContent = badgeText;
        const head = paras.filter(function (p) {
          return isHealthHeadline(p.innerText);
        })[0];
        if (head) head.insertAdjacentElement('afterend', badgeEl);
        else bodies[0].insertAdjacentElement('beforebegin', badgeEl);
      }
      if (!already) {
        root.setAttribute('data-gm-welcome5-injected', '1');
      }
    });
  }

  let injectTimer = 0;
  function scheduleInject() {
    if (injectTimer) return;
    injectTimer = window.setTimeout(function () {
      injectTimer = 0;
      rewriteKlaviyoCopy();
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteKlaviyoCopy);
  } else {
    rewriteKlaviyoCopy();
  }
  const mo = new MutationObserver(scheduleInject);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (cfg.justSubscribed) {
    applyAfterSuccess(cfg.uniqueCode);
  }

  const params = new URLSearchParams(window.location.search);
  if (params.get('test_welcome5') === '1' && cfg.designMode) {
    markSubscribed();
    persist(CODE);
    maybeApplyFromCookie();
  } else {
    maybeApplyFromCookie();
  }
})();
